import { createIcon } from '../icon'
import LockIcon from '@/components/atoms/svg/LockIcon'

export const LockIconDefault = createIcon(LockIcon)
